import React from 'react';
import { ModelFactory } from '@leverege/ui-plugin';
import { List, Text, Flex, Button } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.detail.DetailListRenderer');
export default function DetailListRenderer(props) {
  const {
    item,
    onEvent,
    deleteable = true,
    onParentChange,
    ...rest
  } = props;
  const onDelete = deleteable ? e => {
    onEvent({
      type: 'child.remove',
      item,
      data: props.eventData
    });
  } : null;
  let name;
  const model = ModelFactory.get(item.type);
  if (model) {
    name = model?.getName(item);
  }
  if (name == null) {
    name = item.displayName || item.name || item.type || t('unknown');
  }
  return /*#__PURE__*/_jsx(List.Item, {
    item: item,
    ...rest,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      justify: "space-between",
      align: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "listItemSubtitle",
        children: name
      }), deleteable && /*#__PURE__*/_jsx(Button, {
        variant: "link",
        eventData: item,
        onClick: onDelete,
        icon: "fa fa-trash"
      })]
    })
  });
}